export default __webpack_public_path__ + "static/media/statement-empty-template.5ce47a5c.svg";